<template>
  <div>
    <div
      class="image-uploader"
      :class="{ smallImageUploader: small, uploaded: url }"
    >
      <v-dropzone
        :ref="dropZoneId"
        :id="dropZoneId"
        class="image-uploader-style"
        :options="dropzoneOptions"
        @vdropzone-removed-file="vDzRemove"
        @vdropzone-max-files-exceeded="vDzMaxFilesExceeded"
        @vdropzone-max-files-reached="vDzMaxFilesReached"
        @vdropzone-file-added-manually="vDzMounted"
        @vdropzone-files-added="uploadFiles"
      >
      </v-dropzone>
      <div v-if="cropFirst && imageToBeCropped">
        <v-dialog v-model="cropDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span
                v-if="cropStep === 'selectAspectRatio'"
                class="headline animated fadeIn"
              >
                Select Image Dimensions
              </span>
              <span v-if="cropStep === 'crop'" class="headline animated fadeIn">
                Crop Your Image
              </span>
            </v-card-title>
            <v-card-text>
              <v-layout
                v-if="cropStep === 'selectAspectRatio'"
                class="animated fadeIn"
              >
                <v-flex xs6>
                  <v-card>
                    <v-img :src="imageToBeCropped" aspect-ratio="1"></v-img>

                    <v-card-title primary-title>
                      <div>
                        <h3 class="headline mb-0">Square</h3>
                      </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn color="primary" block @click="selectAspectRatio(1)"
                        >Select</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs6>
                  <v-card>
                    <v-img :src="imageToBeCropped" aspect-ratio="1.5"></v-img>

                    <v-card-title primary-title>
                      <div>
                        <h3 class="headline mb-0">Landscape</h3>
                      </div>
                    </v-card-title>

                    <v-card-actions>
                      <v-btn
                        color="primary"
                        block
                        @click="selectAspectRatio(1.5)"
                        >Select</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
              <div class="animated fadeIn" v-if="cropStep === 'crop'">
                <cropper
                  ref="cropper"
                  classname="cropper"
                  :src="imageToBeCropped"
                  :stencilProps="{
                    aspectRatio,
                  }"
                />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="cropStep === 'crop' && !cropSaveLoading"
                color="black"
                flat
                @click="cropStep = 'selectAspectRatio'"
                >Back</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="error" flat @click="handleCropDialogClose"
                >Close</v-btn
              >
              <v-btn
                color="primary"
                :disabled="cropStep === 'selectAspectRatio'"
                :loading="cropSaveLoading"
                @click="cropAndSave"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div class="pdf-preview" v-if="fileType === 'pdf' && fileThumb">
        <img :src="fileThumb" alt="" />
      </div>
      <div
        v-if="this.url && !loading"
        :class="`open-image-dialog-${dropZoneId}`"
        class="replace-image"
      >
        <span class="d-block"></span>
      </div>
      <div
        v-if="!this.url && !loading"
        :class="`open-image-dialog-${dropZoneId}`"
        class="upload-image"
      >
        <div v-if="dragPlaceholder && !small">
          <span class="d-block primary--text mt-5">{{ dragPlaceholder }}</span>
          <span class="grey--text text--darken-2"
            >Up to {{ maxFileSize }} MB</span
          >
        </div>

        <slot v-else name="placeholder" />
      </div>
      <div class="image-loader" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
          id="loading"
        ></v-progress-circular>
      </div>
      <div class="image-removal" v-if="canRemove && url" @click="removeFile">
        <slot name="icon">
          <span class="v-btn theme--light error"
            ><v-icon>delete_outline</v-icon></span
          >
        </slot>
      </div>
    </div>
    <div v-if="!this.url && validation" class="error--text mt-1">File Is Required</div>
  </div>
</template>

<script>
import generatePdfThumbnails from "pdf-thumbnails-generator";

import { Cropper } from "vue-advanced-cropper";
import vDropzone from "vue2-dropzone";
import fileValidationMixin from "../../../../../mixins/fileValidationMixin";
import common from "../../../../../utils/common";
export default {
  name: "image-uploader",
  mixins: [fileValidationMixin],
  props: {
    url: {
      type: String,
      default: () => {
        return "";
      },
    },
    uploadUrl: {
      type: String,
      default: "/file/upload",
    },
    uploadInstance: {
      type: [Object, Function],
      default: null,
    },
    small: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    validation: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    dragPlaceholder: {
      type: String,
      default: "Choose a file or drag & drop it here",
    },
    cropFirst: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "botter-image-icon",
    },
    type: {
      type: String,
      default: "image",
    },
    types: {
      type: String,
      default: "image/*",
    },
    maxFiles: {
      type: [String, Number],
      default: 1,
    },
    maxFileSize: {
      type: [String, Number],
      default: 5,
    },
    canRemove: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    acceptOnlySheets: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  components: {
    vDropzone,
    Cropper,
  },
  data() {
    return {
      dropZoneId: `vueDropzone${this._uid}`,
      cropDialog: false,
      cropStep: null,
      aspectRatio: 1,
      cropSaveLoading: false,
      imageToBeCropped: null,
      loading: false,
      sheetsAcceptedTypes: {
        xlsx: "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      dropzoneOptions: {
        url: "#",
        thumbnailWidth: 300,
        maxFilesize: +this.maxFileSize,
        maxFiles: +this.maxFiles,
        addRemoveLinks: true,
        autoProcessQueue: false,
        acceptedFiles: `${this.types ? this.types : `${this.type}/*`}`,
        previewTemplate: this.getTemplate(),
        dictDefaultMessage: this.icon
          ? `<span class="${this.icon} primary-text text-lg-2" />`
          : "",
      },
      fileType: "",
      fileSize: "",
      fileThumb: "",
      fileNumOfPages: 0,
    };
  },

  mounted() {
    this.loadImg();
    this.$on("onFileRemove", () => {
      this.cropDialog = false;
    });
    // let image = document.querySelector(`.vueDropzone${this.dropZoneId} img`);
  },
  // beforeDestroy() {
  //   console.log("Destroy");
  //   this.removeFile();
  // },
  computed: {
    axiosInstance() {
      return this.uploadInstance ? this.uploadInstance : this.$http_uploads;
    },
  },
  methods: {
    clear() {
      this.$refs[this.dropZoneId].removeAllFiles();
    },
    vDzRemove(file, error, xhr) {},
    vDzMaxFilesExceeded(file) {
      // Disable exceeding maximum allowed files in VueDropzone
      this.$refs[this.dropZoneId].removeFile(file);
    },
    vDzMaxFilesReached() {
      if (this.$refs[this.dropZoneId].dropzone.files.length < 2) {
        // this.$refs.vueDropzone.enable()
      } else {
        this.$refs[this.dropZoneId].removeFile(
          this.$refs[this.dropZoneId].dropzone.files[0]
        );
      }
    },
    vDzMounted() {},
    getTemplate() {
      return `

                    <div id="template-preview">
                            <div class="dz-preview dz-file-preview well" id="dz-preview-template">
                                    <div class="preview"><img data-dz-thumbnail /></div>
                            </div>
                    </div>
                    `;
    },
    loadImg() {
      if (this.url) {
        this.$refs[this.dropZoneId].removeAllFiles();
        let file = { size: 123, name: "Image", type: "image/*" };
        this.$refs[this.dropZoneId].manuallyAddFile(file, this.url);
      } else {
        this.$refs[this.dropZoneId].removeAllFiles(true);
      }
    },
    openDialog() {
      // this.$refs.vueDropzone.removeAllFiles()
    },
    cropAndSave() {
      const result = this.$refs.cropper.getResult();
      const imageDataUrl = result.canvas.toDataURL("image/jpeg");
      const file = this.dataURLtoFile(imageDataUrl, `nameToBe${Date.now()}`);
      this.uploadCroppedImage(file);
    },
    handleCropScenario(file) {
      if (file && file[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
          this.imageToBeCropped = reader.result;
          this.cropStep = "selectAspectRatio";
          this.cropDialog = true;
        };
      }
    },
    selectAspectRatio(aspectRatio) {
      this.aspectRatio = aspectRatio;
      this.cropStep = "crop";
    },
    handleCropDialogClose() {
      this.clear();
      this.cropDialog = false;
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    uploadCroppedImage(file) {
      this.cropSaveLoading = true;
      let formObject = new FormData();
      formObject.append("file", file);
      this.axiosInstance
        .post(this.uploadUrl, formObject)
        .then((response) => {
          this.$emit("onImageUpload", {
            url: response.data.url,
            aspectRatio: this.aspectRatio,
          });
          this.cropSaveLoading = false;
        })
        .catch((err) => {
          this.cropSaveLoading = false;
          if (err && err.response && err.response.status === 401) {
            common.logOut();
          } else {
            let msg =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : "Upload Failed";
            this.$store.dispatch("setErrorMessage", msg);
            this.$emit("error", err);
          }
        });
    },
    async uploadFiles(files) {
      this.loading = true;
      try {
        if (!files.length) {
          this.loading = false;
          throw `No files detected`;
        }
        const uploadedFiles = [];
        for (const file of files) {
          let formObject = new FormData();
          formObject.append("file", file);
          const response = await this.axiosInstance.post(
            this.uploadUrl,
            formObject,
            {
              params: {
                source: "dashboard",
              },
            }
          );

          this.$emit("onImageUpload", {
            url: response.data.url,
            name: response.data.name,
            size: file.size,
          });
          this.$emit("onFileUpload", {
            url: response.data.url,
            name: response.data.name,
            size: file.size,
          });
          uploadedFiles.push({
            url: response.data.url,
            name: response.data.name,
            size: file.size,
          });
          if (uploadedFiles.length === files.length) {
            this.$emit("onUploadComplete", uploadedFiles);
            this.loading = false;
          }
        }
      } catch (err) {
        this.loading = false;
        throw err;
      }
    },
    removeFile() {
      this.$refs[this.dropZoneId].removeAllFiles(true);
      this.$emit("onFileRemove", "");
    },
    async getFileThumb() {
      try {
        const thumbnails = await generatePdfThumbnails(this.url, 400);
        this.fileThumb = thumbnails[0].thumbnail;
        this.fileNumOfPages = thumbnails.length;
      } catch (err) {
        console.error(err);
        this.fileThumb = "";
      }
    },
  },
  watch: {
    url(val) {
      if(!val) return; 
      this.loadImg();
      this.validateFileUrlType(val);
      this.fileType = this.url.split(".").pop()
        ? this.url.split(".").pop().toLowerCase()
        : "undefined";
      if (this.fileType === "pdf") {
        this.getFileThumb();
      }
    },
  },
};
</script>

<style scoped>
.image-uploader-style {
}
.image-removal {
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
}
.image-uploader:hover .image-removal {
  display: flex;
}
</style>
